import { $ as e, A as t, C as n, F as r, L as i, M as a, R as o, S as s, T as c, U as l, V as u, W as d, X as f, Y as p, _ as m, at as h, et as g, g as _, h as v, i as y, m as b, nt as x, ot as S, p as C, q as w, rt as T, t as E, tt as D, v as O, w as k } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as A } from "./i18n-lite-BcmwMblk.js";
import { n as j, r as M, t as N } from "./normalize-props-DNjMoRjC.js";
import { t as P } from "./ButtonTooltip.ce-Cd_TCG5Y.js";
import { t as F } from "./NavigationButton.ce-D8WGMxzc.js";
//#region src/webcomponents/pix-carousel/locales/de-AT.json
var ee = {}, te = { "pix-carousel": {
	license: "Image license",
	next: "Next",
	of: "{{ currentSlide }} of {{ slideLength }}",
	previous: "Previous",
	slide: "Slide",
	title: "Carousel"
} }, ne = {}, re = { "pix-carousel": {
	license: "Licencia de imagen",
	next: "Siguiente",
	of: "{{ currentSlide }} de {{ slideLength }}",
	previous: "Anterior",
	slide: "Diapositiva",
	title: "Carrusel"
} }, ie = { "pix-carousel": {
	license: "Licence de l’image",
	next: "Suivant",
	of: "{{ currentSlide }} sur {{ slideLength }}",
	previous: "Précédent",
	slide: "Diapositive",
	title: "Carrousel"
} }, I = { "pix-carousel": {
	license: "Licence de l’image",
	of: "{{ currentSlide }} sur {{ slideLength }}",
	next: "Suivant",
	previous: "Précédent",
	slide: "Diapositive",
	title: "Carrousel"
} }, L = { "pix-carousel": {
	license: "Licenza d'immagine",
	next: "Avanti",
	of: "{{ currentSlide }} di {{ slideLength }}",
	previous: "Precedente",
	slide: "Diapositiva",
	title: "Galleria"
} }, R = { "pix-carousel": {
	license: "Afbeeldingslicentie",
	next: "Volgende",
	of: "{{ currentSlide }} van {{ slideLength }}",
	previous: "Vorige",
	slide: "Dia",
	title: "Carrousel"
} };
//#endregion
//#region node_modules/@vueuse/shared/dist/index.js
function z(e, t) {
	return p() ? (f(e, t), !0) : !1;
}
var B = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function V(e) {
	return Array.isArray(e) ? e : [e];
}
function H(e) {
	return e || c();
}
function U(e, n = !0, r) {
	H(r) ? a(e, r) : n ? e() : t(e);
}
//#endregion
//#region node_modules/@vueuse/core/dist/index.js
var W = B ? window : void 0;
B && window.document, B && window.navigator, B && window.location;
function G(e) {
	let t = D(e);
	return t?.$el ?? t;
}
function K() {
	let e = g(!1), t = c();
	return t && a(() => {
		e.value = !0;
	}, t), e;
}
/* @__NO_SIDE_EFFECTS__ */
function q(e) {
	let t = K();
	return b(() => (t.value, !!e()));
}
function J(e, t, n = {}) {
	let { window: r = W, ...i } = n, a, o = /* @__PURE__ */ q(() => r && "ResizeObserver" in r), s = () => {
		a &&= (a.disconnect(), void 0);
	}, c = b(() => {
		let t = D(e);
		return Array.isArray(t) ? t.map((e) => G(e)) : [G(t)];
	}), l = d(c, (e) => {
		if (s(), o.value && r) {
			a = new ResizeObserver(t);
			for (let t of e) t instanceof Element && a.observe(t, i);
		}
	}, {
		immediate: !0,
		flush: "post"
	}), u = () => {
		s(), l();
	};
	return z(u), {
		isSupported: o,
		stop: u
	};
}
function Y(e, t = {
	width: 0,
	height: 0
}, n = {}) {
	let { window: r = W, box: i = "content-box" } = n, a = b(() => {
		var t;
		return (t = G(e)) == null || (t = t.namespaceURI) == null ? void 0 : t.includes("svg");
	}), o = g(t.width), s = g(t.height), { stop: c } = J(e, ([t]) => {
		let n = i === "border-box" ? t.borderBoxSize : i === "content-box" ? t.contentBoxSize : t.devicePixelContentBoxSize;
		if (r && a.value) {
			let t = G(e);
			if (t) {
				let e = t.getBoundingClientRect();
				o.value = e.width, s.value = e.height;
			}
		} else if (n) {
			let e = V(n);
			o.value = e.reduce((e, { inlineSize: t }) => e + t, 0), s.value = e.reduce((e, { blockSize: t }) => e + t, 0);
		} else o.value = t.contentRect.width, s.value = t.contentRect.height;
	}, n);
	U(() => {
		let n = G(e);
		if (n && "offsetWidth" in n) {
			if (i === "content-box" && r) {
				let e = r.getComputedStyle(n), t = Number.parseFloat(e.paddingLeft) + Number.parseFloat(e.paddingRight), i = Number.parseFloat(e.paddingTop) + Number.parseFloat(e.paddingBottom), a = Number.parseFloat(e.borderLeftWidth) + Number.parseFloat(e.borderRightWidth), c = Number.parseFloat(e.borderTopWidth) + Number.parseFloat(e.borderBottomWidth);
				o.value = n.offsetWidth - t - a, s.value = n.offsetHeight - i - c;
			} else o.value = n.offsetWidth, s.value = n.offsetHeight;
		} else n && (o.value = t.width, s.value = t.height);
	});
	let l = d(() => G(e), (e) => {
		o.value = e ? t.width : 0, s.value = e ? t.height : 0;
	});
	function u() {
		c(), l();
	}
	return {
		width: o,
		height: s,
		stop: u
	};
}
//#endregion
//#region common/utils/isHtml.js
function X(e) {
	if (!e) return !1;
	let t = [...e.matchAll(/<(\w+)[^>]*>/gm)];
	if (!t.length) return !1;
	let n = RegExp(`</?${t[0][1]}/?>`, "gm");
	return e.match(n);
}
//#endregion
//#region src/webcomponents/pix-carousel/SlideInfo.ce.vue?vue&type=script&setup=true&lang.ts
var ae = ["aria-level"], oe = ["innerHTML"], se = {
	key: 1,
	class: "description"
}, Z = /*#__PURE__*/ E(/* @__PURE__ */ k({
	__name: "SlideInfo.ce",
	props: {
		description: { type: String },
		title: { type: String },
		titleLevel: { type: Number },
		isActive: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (r(), O("div", { class: T(["slide-info", { active: e.isActive }]) }, [v("div", {
			role: "heading",
			"aria-level": e.titleLevel,
			class: "title"
		}, [o(t.$slots, "pagination"), s(" " + S(e.title), 1)], 8, ae), x(X)(e.description) ? (r(), O("div", {
			key: 0,
			class: "description",
			innerHTML: e.description
		}, null, 8, oe)) : e.description ? (r(), O("p", se, S(e.description), 1)) : m("", !0)], 2));
	}
}), [["styles", [".slide-info{border-left:1px solid #0000;grid-area:1/1;height:fit-content;padding-top:4px;padding-left:16px;transform:translate(100vw)}.slide-info p{margin-top:8px;margin-bottom:0}.slide-info.active{border-left-color:gray;transform:translate(0)}.slide-info .title{min-height:24px;font-family:Nunito,sans-serif;font-size:1.25rem;font-style:normal;font-weight:700;line-height:1.75rem}.slide-info .description{font-size:.875rem}.slide-info .description ul li,.slide-info .description ol li{margin-left:1rem}@media only screen and (width<=576px){.slide-info.active{border:none;padding-left:0}}"]]]), ce = [
	"aria-hidden",
	"aria-roledescription",
	"aria-label"
], le = {
	key: 0,
	class: "image-container"
}, ue = ["alt", "src"], de = {
	key: 0,
	class: "license"
}, fe = ["href"], pe = { class: "img-container" }, me = ["alt", "src"], he = ["innerHTML"], ge = {
	key: 1,
	class: "text-container"
}, _e = ["innerHTML"], ve = /*#__PURE__*/ E(/* @__PURE__ */ k({
	__name: "Slide.ce",
	props: {
		slide: { type: Object },
		isActive: { type: Boolean },
		titleLevel: { type: Number },
		label: { type: String },
		direction: { type: Number },
		type: { type: String },
		disableAnimation: { type: Boolean },
		disableStyleAroundImage: { type: Boolean },
		imageTextDisplay: {
			default: "1:2",
			type: String
		}
	},
	setup(t) {
		let i = window.matchMedia("(prefers-reduced-motion: reduce)"), a = t.disableAnimation ?? i.matches, o = e(t.isActive ? "on" : "off"), c = Y(l("container")), [u, f] = t.imageTextDisplay.split(":").map(Number);
		d(() => t.isActive, (e) => {
			e ? (o.value = a ? "on" : "initStart", window.setTimeout(() => {
				o.value === "initStart" && (o.value = "on");
			}, 20)) : (o.value = a ? "off" : "initEnd", window.setTimeout(() => {
				o.value === "initEnd" && (o.value = "off");
			}, 800));
		});
		let p = b(() => t.direction === 1), g = b(() => {
			if (new URL(t.slide.image.src).pathname.endsWith(".svg")) return c.width.value + "px";
		});
		return (e, i) => (r(), O("div", {
			ref: "container",
			role: "group",
			class: T(["slide", {
				active: t.isActive,
				[o.value]: o.value,
				"is-next": p.value,
				"disable-animation": x(a)
			}]),
			"aria-hidden": !t.isActive,
			"aria-roledescription": e.$t("pix-carousel.slide"),
			"aria-label": t.label
		}, [t.type === "image" ? (r(), O("div", le, [v("img", {
			style: h({
				"--max-width": `${t.slide.displayWidth}px`,
				"--max-height": `${t.slide.displayHeight}px`,
				"--svg-image-display": g.value
			}),
			class: T({ "has-shadow": !t.disableStyleAroundImage }),
			alt: t.slide.image.alt,
			src: t.slide.image.src
		}, null, 14, ue), t.slide.license ? (r(), O("p", de, [s(S(t.slide.license.attribution) + " / ", 1), v("a", {
			href: t.slide.license.url,
			target: "_blank"
		}, S(t.slide.license.name), 9, fe)])) : m("", !0)])) : t.type === "image-text" ? (r(), O("div", {
			key: 1,
			class: T(["text-image-container", { "has-shadow": !t.disableStyleAroundImage }]),
			style: h({
				"--image-display": x(u),
				"--text-display": x(f)
			})
		}, [v("div", pe, [v("img", {
			alt: t.slide.image.alt,
			src: t.slide.image.src
		}, null, 8, me)]), x(X)(t.slide.text) ? (r(), O("div", {
			key: 0,
			class: "text-container",
			innerHTML: t.slide.text
		}, null, 8, he)) : t.slide.text ? (r(), O("p", ge, S(t.slide.text), 1)) : m("", !0)], 6)) : (r(), O("div", {
			key: 2,
			class: "text-container",
			innerHTML: t.slide.text
		}, null, 8, _e)), n(Z, {
			description: t.slide.description,
			title: t.slide.title,
			"is-active": t.isActive,
			"title-level": t.titleLevel,
			class: "sr-only"
		}, null, 8, [
			"description",
			"title",
			"is-active",
			"title-level"
		])], 10, ce));
	}
}), [["styles", [".slide{height:100%;transition:transform .8s ease-in-out}.slide.off,.slide.initStart{transition:none;transform:translate(100vw)}.slide.initStart.is-next,.slide.initEnd{transform:translate(-100vw)}.slide.initEnd.is-next{transform:translate(100vw)}.slide.on{transform:translate(0)}.slide.disable-animation{transition:none}.image-container{border-radius:8px;justify-content:center;align-items:center;max-width:890px;margin:auto;display:flex;position:relative}.image-container--is-not-image{justify-content:left}.image-container img{height:100%;max-width:var(--max-width);max-height:var(--max-height);width:var(--svg-image-display,100%);object-fit:contain;border-radius:16px}.image-container img.has-shadow{filter:drop-shadow(0 8px 12px #0003)}.license{text-align:center;background:#ffffffe6;border-top-left-radius:8px;border-top-right-radius:8px;max-width:50%;margin:0;padding:2px 8px;font-size:.8rem;position:absolute;bottom:0}.text-container{width:fit-content;margin:auto}.text-image-container{background:#fff;border-radius:16px;flex:1;gap:12px;padding:16px;display:flex}.text-image-container.has-shadow{filter:drop-shadow(0 8px 12px #0003)}.text-image-container .img-container{width:calc(var(--image-display) / (var(--image-display) + var(--text-display)) * 100%);justify-content:center;align-items:center;display:flex}.text-image-container .img-container img{width:auto;max-width:100%;height:auto}.text-image-container .text-container{width:calc(var(--text-display) / (var(--image-display) + var(--text-display)) * 100%)}.text-image-container .text-container>*{margin:0}@media only screen and (width<=576px){.license{font-size:.5rem}.image-container img{border-radius:8px;width:95%}.text-image-container{flex-direction:column}.text-image-container .img-container,.text-image-container .text-container{width:100%}}@media (prefers-reduced-motion:reduce){.slide{transition:none}}"]]]), ye = {}, be = {
	width: "25",
	height: "24",
	viewBox: "0 0 25 24",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true"
};
function xe(e, t) {
	return r(), O("svg", be, [...t[0] ||= [v("path", {
		d: "M11.6579 11.9996L15.4624 15.8039C15.6735 16.0152 15.7791 16.2804 15.7791 16.5996C15.7791 16.9188 15.6735 17.184 15.4624 17.3954C15.251 17.6065 14.9858 17.7121 14.6666 17.7121C14.3474 17.7121 14.0822 17.6065 13.8709 17.3954L9.27685 12.8014C9.16502 12.6894 9.08327 12.565 9.0316 12.4284C8.97994 12.2919 8.9541 12.1489 8.9541 11.9996C8.9541 11.8503 8.97994 11.7074 9.0316 11.5709C9.08327 11.4342 9.16502 11.3099 9.27685 11.1979L13.8709 6.60386C14.0822 6.39269 14.3474 6.28711 14.6666 6.28711C14.9858 6.28711 15.251 6.39269 15.4624 6.60386C15.6735 6.81519 15.7791 7.08044 15.7791 7.39961C15.7791 7.71878 15.6735 7.98403 15.4624 8.19536L11.6579 11.9996Z",
		fill: "inherit"
	}, null, -1)]]);
}
var Q = /*#__PURE__*/ E(ye, [["render", xe]]), Se = {}, Ce = {
	width: "25",
	height: "24",
	viewBox: "0 0 25 24",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true"
};
function we(e, t) {
	return r(), O("svg", Ce, [...t[0] ||= [v("path", {
		d: "M13.0754 11.9996L9.27085 8.19536C9.05969 7.98403 8.9541 7.71878 8.9541 7.39961C8.9541 7.08044 9.05969 6.81519 9.27085 6.60386C9.48219 6.39269 9.74743 6.28711 10.0666 6.28711C10.3858 6.28711 10.651 6.39269 10.8624 6.60386L15.4564 11.1979C15.5682 11.3099 15.6499 11.4342 15.7016 11.5709C15.7533 11.7074 15.7791 11.8503 15.7791 11.9996C15.7791 12.1489 15.7533 12.2919 15.7016 12.4284C15.6499 12.565 15.5682 12.6894 15.4564 12.8014L10.8624 17.3954C10.651 17.6065 10.3858 17.7121 10.0666 17.7121C9.74743 17.7121 9.48219 17.6065 9.27085 17.3954C9.05969 17.184 8.9541 16.9188 8.9541 16.5996C8.9541 16.2804 9.05969 16.0152 9.27085 15.8039L13.0754 11.9996Z",
		fill: "inherit"
	}, null, -1)]]);
}
var Te = /*#__PURE__*/ E(Se, [["render", we]]), Ee = ["aria-roledescription"], De = ["id"], Oe = { class: "footer" }, ke = { class: "control" }, Ae = { class: "slide-info-container" }, je = { class: "pagination" }, Me = /*#__PURE__*/ E(/* @__PURE__ */ k({
	__name: "Carousel.ce",
	props: {
		randomSlides: { type: Boolean },
		type: { type: String },
		slides: { type: Array },
		titleLevel: { type: Number },
		disableAnimation: { type: Boolean },
		enableLoop: { type: Boolean },
		disableStyleAroundImage: { type: Boolean },
		imageTextDisplay: { type: String }
	},
	setup(t) {
		let a = t, o = a.titleLevel ?? 2, s = b(() => a.randomSlides ? [...a.slides].sort(() => Math.round(Math.random()) === 0 ? -1 : 1) : a.slides), c = e(0), l = e(1), d = b(() => !a.enableLoop && c.value === 0), f = b(() => !a.enableLoop && c.value === a.slides.length - 1);
		function p(e) {
			l.value = e, c.value = (c.value - e + a.slides.length) % a.slides.length;
		}
		let m = u();
		return (e, a) => (r(), O("section", { "aria-roledescription": e.$t("pix-carousel.title") }, [v("div", {
			id: x(m),
			"aria-live": "polite",
			class: "slides"
		}, [
			n(P, {
				class: "carousel__nav previous",
				disabled: d.value,
				"aria-controls": x(m),
				label: e.$t("pix-carousel.previous"),
				"tooltip-position": "right",
				onClick: a[0] ||= (e) => p(1)
			}, {
				default: w(() => [n(Q)]),
				_: 1
			}, 8, [
				"disabled",
				"aria-controls",
				"label"
			]),
			(r(!0), O(C, null, i(s.value, (n, i) => (r(), _(ve, {
				key: i,
				slide: n,
				direction: l.value,
				label: e.$t("pix-carousel.of", {
					currentSlide: i + 1,
					slideLength: s.value.length
				}),
				"is-active": c.value === i,
				"title-level": x(o),
				type: t.type,
				"disable-animation": t.disableAnimation,
				"disable-style-around-image": t.disableStyleAroundImage,
				"image-text-display": t.imageTextDisplay
			}, null, 8, [
				"slide",
				"direction",
				"label",
				"is-active",
				"title-level",
				"type",
				"disable-animation",
				"disable-style-around-image",
				"image-text-display"
			]))), 128)),
			n(P, {
				class: "carousel__nav next",
				disabled: f.value,
				"aria-controls": x(m),
				label: e.$t("pix-carousel.next"),
				"tooltip-position": "left",
				onClick: a[1] ||= (e) => p(-1)
			}, {
				default: w(() => [n(Te)]),
				_: 1
			}, 8, [
				"disabled",
				"aria-controls",
				"label"
			])
		], 8, De), v("div", Oe, [v("div", ke, [n(F, {
			label: e.$t("pix-carousel.previous"),
			"aria-controls": x(m),
			direction: "previous",
			disabled: d.value,
			onClick: a[2] ||= (e) => p(1)
		}, null, 8, [
			"label",
			"aria-controls",
			"disabled"
		]), n(F, {
			label: e.$t("pix-carousel.next"),
			"aria-controls": x(m),
			direction: "next",
			disabled: f.value,
			onClick: a[3] ||= (e) => p(-1)
		}, null, 8, [
			"label",
			"aria-controls",
			"disabled"
		])]), v("div", Ae, [(r(!0), O(C, null, i(s.value, (e, t) => (r(), _(Z, {
			key: t,
			description: e.description,
			title: e.title,
			"title-level": x(o),
			"is-active": c.value === t,
			"aria-hidden": "true"
		}, {
			pagination: w(() => [v("span", je, S(t + 1) + " / " + S(s.value.length), 1)]),
			_: 2
		}, 1032, [
			"description",
			"title",
			"title-level",
			"is-active"
		]))), 128))])])], 8, Ee));
	}
}), [["styles", ["*{--pix-neutral-0:white;--pix-neutral-100:#cdd1d9;--pix-neutral-800:#253858;--pix-primary-100:#cec3f4;--pix-primary-300:#957ee8;--pix-primary-700:#452d9d;--pix-primary-900:#291a5d;color:var(--pix-neutral-800);font-family:Roboto,sans-serif}section{flex-direction:column;gap:12px;padding-top:12px;display:flex;overflow:hidden}section .slides{grid-template-columns:32px auto 32px;gap:16px;width:100%;display:grid}section .slides .slide{grid-area:1/2;align-items:center;display:flex}section .slides .carousel__nav{background:var(--pix-primary-100);height:80%;fill:var(--pix-neutral-800);cursor:pointer;z-index:9;border:none;margin:auto 0;padding:0}section .slides .carousel__nav:hover{background:var(--pix-primary-300);fill:var(--pix-neutral-0)}section .slides .carousel__nav:active,section .slides .carousel__nav:focus,section .slides .carousel__nav:focus-visible{background:var(--pix-primary-700);fill:var(--pix-neutral-0)}section .slides .carousel__nav:focus,section .slides .carousel__nav:focus-visible{outline-offset:-4px;outline:1px solid var(--pix-neutral-0)}section .slides .carousel__nav.previous{border-top-right-radius:1rem;border-bottom-right-radius:1rem}section .slides .carousel__nav.next{border-top-left-radius:1rem;border-bottom-left-radius:1rem}section .slides .carousel__nav.disabled,section .slides .carousel__nav.disabled:hover{cursor:not-allowed;fill:var(--pix-neutral-100);background:0 0}.footer{align-items:start;gap:16px;padding:16px 56px;display:flex}.footer .footer-separator{border-left:1px solid;width:1px}.footer .control{align-items:center;gap:8px;display:flex}.footer .tooltip-container button.disabled{fill:var(--pix-neutral-100)}.footer .slide-info-container{grid-template-columns:1fr;display:grid}.footer .slide-info-container .pagination{color:var(--pix-primary-900);background-color:var(--pix-primary-100);text-wrap:nowrap;border-radius:50px;align-items:center;height:18px;padding:3px 12px;font-family:Roboto,sans-serif;font-size:.75rem;font-weight:400;display:inline-flex;transform:translateY(-.25rem)}.footer .info{display:grid;overflow:hidden}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}@media only screen and (width<=576px){section .slides{grid-template-columns:0 100% 0;gap:0}section .slides .carousel__nav{display:none}.footer{flex-direction:column;padding:16px}.footer .footer-separator{display:none}}"]]]);
//#endregion
//#region src/webcomponents/pix-carousel/pix-carousel.ce.js
A.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": ee,
	"./locales/en.json": te,
	"./locales/es-419.json": ne,
	"./locales/es.json": re,
	"./locales/fr-BE.json": ie,
	"./locales/fr.json": I,
	"./locales/it.json": L,
	"./locales/nl.json": R
}));
var $ = y(Me, { configureApp(e) {
	A.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(A);
} });
$.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: N(e.titleLevel),
	imageTextDisplay: M(e.imageTextDisplay),
	slides: e.slides.map((e) => ({
		...e,
		displayHeight: N(e.displayHeight),
		displayWidth: N(e.displayWidth),
		license: j(e.license)
	}))
}), window.customElements.define("pix-carousel", $);
//#endregion
